import {useNavigate} from 'react-router-dom'
import {usePageTitle} from '@/hooks/use-page-title'
import {AccessProfileForm} from '@/components/AccessProfileForm'
import {useI18n} from '@/i18n'
import {useServices} from '@/services/context'
import {routes} from '@/lib/routes'
import type {AccessProfileCreateRequest, AccessProfileUpdateRequest} from '@/types/access-profile'
import {useEntityMutation} from '@/hooks/useEntityMutation'
import {PageLayout} from '@/components/shared/PageLayout'
import {CONCEPT_ICON} from '@/lib/concepts'

export function AccessProfileCreate() {
    const services = useServices()
    const i18n = useI18n()
    usePageTitle(i18n.accessProfiles.createPageTitle)
    const navigate = useNavigate()

    const createMutation = useEntityMutation({
        mutationFn: (data: AccessProfileCreateRequest) =>
            services.accessProfiles.create(data),
        invalidate: ['access-profiles'],
        successMessage: i18n.accessProfiles.profileCreated,
        onSuccess: (profile) => {
            navigate(routes.accessGovernance.profiles.detail(profile.id))
        },
    })

    const handleSubmit = async (data: AccessProfileCreateRequest | AccessProfileUpdateRequest) => {
        await createMutation.mutateAsync(data as AccessProfileCreateRequest)
    }

    return (
        <PageLayout
            variant="detail"
            title={i18n.accessProfiles.createProfile}
            description={i18n.accessProfiles.createCardDesc}
            icon={CONCEPT_ICON.accessProfile}
            backTo={true}
            data-testid="access-profile-create-page"
        >
            <AccessProfileForm
                onSubmit={handleSubmit}
                onCancel={() => navigate(-1)}
                isLoading={createMutation.isPending}
            />
        </PageLayout>
    )
}
